export default {
    namespaced: true,
    state: {
        obj: {},
        objs: [],
    },
    mutations: {
        setObjs(state, pload) {
            state.objs = pload;
        },
        setObj(state, pload) {
            state.obj = pload;
        },
    },
    actions: {
        getObj({rootState}, id) {
            return new Promise((resolve, reject) => {
                let url = `${rootState.config.apiHost}master-data-menu/${id}`;
                this._vm.$axios.get(url, { headers: { 'Authorization': 'Bearer ' + rootState.token, 'Content-Type': 'application/json' } })
                    .then(response => {
                        resolve(response.data.data)
                    }, error => {
                        reject(error)
                    });
            })
        },
        getObjs({rootState}) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + 'master-data-menu';
                this._vm.$axios.get(url, {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    });
            })
        },
        getObjsByVolume({rootState}, volume) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + `master-data-menu/volume/${volume}`;
                this._vm.$axios.get(url, {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    });
            })
        },
        save({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "master-data-menu";
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    });
            })
        },
        update({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + `master-data-menu/${payload.id}/update`;
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    });
            })
        }
    }
}